import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi } from '../../api/adminApi';

export default function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  // --- Стан для кастомного модального вікна ---
  const [modal, setModal] = useState<{
    show: boolean;
    title: string;
    message: string;
  }>({ show: false, title: '', message: '' });

  const showAlert = (title: string, message: string) => {
    setModal({ show: true, title, message });
  };

  const closeModal = () => setModal(prev => ({ ...prev, show: false }));
  // -------------------------------------------

  const login = async () => {
    if (!username || !password) {
      return showAlert('Увага', 'Будь ласка, введіть логін та пароль');
    }

    try {
      // cookie встановлюється на сервері
      await adminApi.login(username, password);
      
      // Замість alert просто редиректимо, або показуємо успіх
      navigate('/admin');
    } catch (err) {
      console.error(err);
      showAlert('Помилка', 'Невірний логін або пароль');
    }
  };

  // Вхід по натисканню Enter
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') login();
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f0f7f4', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Montserrat, sans-serif' }}>
      
      {/* КАСТОМНЕ МОДАЛЬНЕ ВІКНО */}
      {modal.show && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <h4 style={{ marginTop: 0, color: '#2d5a50' }}>{modal.title}</h4>
            <p style={{ color: '#666', fontSize: '15px', marginBottom: '25px' }}>{modal.message}</p>
            <button onClick={closeModal} style={modalPrimaryBtnStyle}>ОК</button>
          </div>
        </div>
      )}

      <div style={{ maxWidth: 400, width: '90%', background: '#fff', padding: '40px', borderRadius: '16px', boxShadow: '0 10px 25px rgba(0,0,0,0.05)' }}>
        <h2 style={{ textAlign: 'center', color: '#2d5a50', marginBottom: '30px', fontWeight: 700 }}>Вхід модератора</h2>

        <div onKeyDown={handleKeyDown}>
          <input
            placeholder="Логін"
            value={username}
            onChange={e => setUsername(e.target.value)}
            style={inputStyle}
          />

          <input
            type="password"
            placeholder="Пароль"
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={{ ...inputStyle, marginBottom: '25px' }}
          />

          <button
            onClick={login}
            style={loginBtnStyle}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#16a085'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#1abc9c'}
          >
            Увійти
          </button>
        </div>
      </div>
    </div>
  );
}

// --- Стилі ---
const modalOverlayStyle: React.CSSProperties = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
  justifyContent: 'center', alignItems: 'center', zIndex: 1000,
  backdropFilter: 'blur(2px)'
};

const modalContentStyle: React.CSSProperties = {
  background: '#fff', padding: '30px', borderRadius: '15px',
  maxWidth: '350px', width: '85%', boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
  textAlign: 'center', animation: 'fadeIn 0.3s ease'
};

const modalPrimaryBtnStyle = {
  padding: '10px 30px', background: '#1abc9c', color: '#fff',
  border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' as const
};

const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '14px',
  marginBottom: '15px',
  borderRadius: '10px',
  border: '2px solid #edf2f0',
  boxSizing: 'border-box',
  fontSize: '15px',
  outline: 'none',
  transition: 'border-color 0.3s'
};

const loginBtnStyle: React.CSSProperties = {
  width: '100%',
  padding: '15px',
  cursor: 'pointer',
  backgroundColor: '#1abc9c',
  color: '#fff',
  border: 'none',
  borderRadius: '10px',
  fontWeight: 'bold',
  fontSize: '16px',
  transition: 'all 0.3s ease'
};